var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"html-safe",rawName:"v-html-safe",value:(_setup.html),expression:"html"}],staticClass:"fp-markdown"})
}
var staticRenderFns = []

export { render, staticRenderFns }